export default __webpack_public_path__ + "static/media/artur 1-compressed.402d8c08.png";